var map = {
	"./approved.png": "7a52",
	"./full_day.png": "1666",
	"./full_day_note.png": "afb7",
	"./home_office.png": "a638",
	"./illness.png": "e3ab",
	"./maternity.png": "d1a2",
	"./self-release.png": "162f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a51a";